import { call, put } from 'redux-saga/effects';
import { questionnaireEvaluationFailureAction, questionnaireEvaluationGetEvaluationIdSuccessAction, questionnaireEvaluationGetEvaluationIdByExternalEvalIdSuccessAction } from '../actions';
import { QuestionnaireEvaluationInitializationService } from '../services';
export function* questionnaireEvaluationGetEvalautionIdSaga(action, questionnaireEvaluationInitializationService = QuestionnaireEvaluationInitializationService.getInstance()) {
    try {
        const questionnaireEvaluationId = yield call({
            context: questionnaireEvaluationInitializationService,
            fn: questionnaireEvaluationInitializationService.questionnaireEvaluationGetEvaluationId
        }, action.payload);
        yield put(questionnaireEvaluationGetEvaluationIdSuccessAction(questionnaireEvaluationId));
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
export function* questionnaireEvaluationGetEvalDocIdFromExternalEvalIdSaga(action, questionnaireEvaluationInitializationService = QuestionnaireEvaluationInitializationService.getInstance()) {
    try {
        const questionnaireEvaluationId = yield call({
            context: questionnaireEvaluationInitializationService,
            fn: questionnaireEvaluationInitializationService.questionnaireEvaluationGetEvalIdFromExternalEvalId
        }, action.payload);
        yield put(questionnaireEvaluationGetEvaluationIdByExternalEvalIdSuccessAction(questionnaireEvaluationId));
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
//# sourceMappingURL=questionnaireEvaluationGetEvaluationIdSaga.js.map